import React from "react";

const Footer = () => {
  return (
    <footer className="border-t border-gray-200 bg-gray-50 dark:bg-gray-800 dark:border-gray-700 py-4">
      <div className="container mx-auto text-center">
        <p className="text-gray-800 dark:text-white">© 2025 Chims Web Dev. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
